const linkList = [
  '/products/planet-of-the-vapes-lobo',
  '/blogs/guide/best-portable-vaporizer-guide',
  '/pages/storz-bickel-vaporizers'
];

const selectorList = linkList.map(link => `[href$="${link}"]`).join(',');
const linkArr = Array.from(document.querySelectorAll(selectorList));

// Init observer after page load
// Use 'ab-speculative-enable' on document body to AB test
window.addEventListener('load', ()=> {
  if (document.body.classList.contains('ab-speculative-enable')) {
    observeVisibleLinks(linkArr);
  }
});

const arr = [];
function observeVisibleLinks(linkArr) {
  // Callback function to execute when intersection changes
  const callback = (entries) => {
    var lastN = 0;

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const target = entry.target;
        const href = decodeURI(target.href);
        
        if (!arr.includes(href)) {
          // We are pushing HREFs in an Array to future implement a prerender limit
          arr.push(href);
          
          window.setTimeout(function(){
            // Prevent Shopify throttle
            target.classList.add('prerender-immediate');
            lastN = lastN + randomNumberBetween100And200();
          }, lastN);

        }
      }
    });

    // Disconect the observer when all links are prerendered
    if (arr.length === linkList.length) {
      observer.disconnect();
    }
  };

  // Create a new intersection observer with the callback function
  const observer = new IntersectionObserver(callback);

  // Observe each <a> element from linkList
  linkArr.forEach(link => {
    observer.observe(link);
  });
}

function randomNumberBetween100And200() {
  return Math.floor(Math.random() * (200 - 100 + 1)) + 100;
}